import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from 'app/_services/report.service';

import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { BrandDataSourceReportService } from './brand-data-source-reports.service';
import { ProjectsService } from 'app/_services/projects.service';
const moment = require('moment');
@Component({
  selector: 'app-brands',
  templateUrl: './brand-data-source-reports.component.html',
  styleUrls: ['./brand-data-source-reports.component.scss']
})
export class BrandDataSourceReportsComponent implements OnInit {
  projectId = "";
  typeAction = 'create';

  brandDropDownSettings: any;
  brandSelectedFilter = [];
  brandSelected = [];
  brands = [
  ];
  sourceByTopic = "";
  reportName = "";
  dataReport: Object;
  projectDropDownSettings: any;
  projectSelected = [];
  projectSelectedFilter = [];
  projects = [];
  notSpam2 = false;
  typeReport = 1;
  typeReportFilter = 1;
  dtOptions: DataTables.Settings = {};
  keywords = '';
  imageSrc: any;
  file: null;
  result: any;
  source_keywords = '';
  listBrands = [];
  dataList = [];
  dataTableShow = false;
  showReport = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  daterange: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  options = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };
  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }
  selectedDateFilter(value: any, datepicker?: any) {

    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
    this.optionsFilter = {
      locale: { format: 'DD/MM/YYYY' },
      timePicker: false,
      timePicker24Hour: true,
      timePickerSeconds: true,
      alwaysShowCalendars: false,
      maxDate: moment().subtract(1, "days").endOf('day').toDate(),
      startDate: this.daterangeFilter.start,
      endDate: this.daterangeFilter.end
    };

  }

  selectedProjects = [];

  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private brandReportService: BrandDataSourceReportService,
    private modalService: BsModalService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: true,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      singleSelection: false,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
      ]
    };
  };


  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    // let await1s = await this.resolveAfter1Seconds()
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }
  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });

  }
  modalRefHide(previewModal) {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(previewModal, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }
  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });

  }

  getDataFromServer() {
    this.dataTableShow = false;
    this.brandReportService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {
    this.dataTableShow = false;
    let type = "day";
    if (this.typeReport == 2) {
      type = "week";
    } else if (this.typeReport == 3) {
      type = "month";
    } else if (this.typeReport == 4) {
      type = "year";
    } else if (this.typeReport == 5) {
      type = "option";
    }
    let filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      typeReport: type,
      report_code: ["BCNDL"]
    };
    this.brandReportService.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
      console.log(this.dataList);
    });
  }

  clickReport() {
    if (this.projectSelectedFilter.length == 0 && this.brandSelectedFilter.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }

    if (this.projectSelectedFilter.length > 10) {
      this.toastrService.warning("Không thể chọn nhiều hơn 10 chủ đề", "Thông báo!");
      return;
    }

    // let timeRange = Math.ceil((this.daterangeFilter.end.valueOf() - this.daterangeFilter.start.valueOf()) / (24 * 60 * 60 * 1000));
    // if (timeRange > 60) {
    //   this.toastrService.warning("Khoảng thời gian chọn không được quá 60 ngày!", "Thông báo!");
    //   return;
    // }

    this.dataReport = {};
    let type = "day";
    if (this.typeReportFilter == 2) {
      type = "week";
    } else if (this.typeReportFilter == 3) {
      type = "month";
    } else if (this.typeReportFilter == 4) {
      type = "year";
    } else if (this.typeReportFilter == 5) {
      type = "option";
    }
    let gte = this.daterangeFilter.start.valueOf();
    if (type == "day") {
      gte -= 6 * 24 * 60 * 60 * 1000;
    }
    let filter = {
      from: this.daterangeFilter.start.valueOf(),
      gte: gte,
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      type: type,
      sourceByTopic: this.sourceByTopic,
      notSpam: this.notSpam2
    };
    this.brandReportService.getReport({ filter: filter, index: "full" }).subscribe(response => {
      let data = response.data;
      if (data) {
        if (type == "day") {
          let aggregations = data.aggregations.dataFilter;
          let comments = aggregations.comment.docsCount.statistic.seg.buckets;
          let posts = aggregations.post.docsCount.statistic.seg.buckets;
          let news = aggregations.news.docsCount.statistic.seg.buckets;
          let newsDomain = aggregations.news.domain.buckets;
          let sentiments = aggregations.sentimentsCount.statistic.topics.buckets;
          this.dataReport = {
            report_desc: "Báo cáo nguồn dữ liệu",
            report_type: type,
            report_name: "Báo cáo nguồn dữ liệu từ ngày " + this.daterangeFilter.start.format('DD/MM/YYYY') + " đến ngày " + this.daterangeFilter.end.format('DD/MM/YYYY'),
            report_project: this.projectSelectedFilter,
            report_brand: this.brandSelectedFilter,
            report_start_date: new Date(this.daterangeFilter.start.valueOf()),
            report_end_date: new Date(this.daterangeFilter.end.valueOf()),
            report_code: "BCNDL",
          };
          let dataSourceReport = {};
          let dataSource = {};
          for (var i = 0; i < comments.length; i++) {
            let key = comments[i]["key"];
            let count = comments[i]["doc_count"];
            if (!dataSource[key]) {
              dataSource[key] = {};
            }
            dataSource[key]["comments"] = count;
          }

          for (var i = 0; i < posts.length; i++) {
            let key = posts[i]["key"];
            let count = posts[i]["doc_count"];
            if (!dataSource[key]) {
              dataSource[key] = {};
            }
            dataSource[key]["posts"] = count;
          }

          for (var i = 0; i < news.length; i++) {
            let key = news[i]["key"];
            let count = news[i]["doc_count"];
            if (!dataSource[key]) {
              dataSource[key] = {};
            }
            dataSource[key]["news"] = count;
          }

          for (var i = 0; i < sentiments.length; i++) {
            let key = sentiments[i]["key"];
            let sentiment = sentiments[i]["seg"]["buckets"];
            if (!dataSource[key]) {
              dataSource[key] = {};
            }
            for (var j = 0; j < sentiment.length; j++) {
              let segKey = sentiment[j].key;
              let segValue = sentiment[j]["doc_count"];
              dataSource[key][segKey] = segValue;
            }
          }

          let topics = Array();
          for (const key in dataSource) {
            let obj = {
              topic: key,
              posts: (dataSource[key]["posts"]) ? dataSource[key]["posts"] : 0,
              news: (dataSource[key]["news"]) ? dataSource[key]["news"] : 0,
              comments: (dataSource[key]["comments"]) ? dataSource[key]["comments"] : 0,
              neu: (dataSource[key]["neu"]) ? dataSource[key]["neu"] : 0,
              pos: (dataSource[key]["pos"]) ? dataSource[key]["pos"] : 0,
              neg: (dataSource[key]["neg"]) ? dataSource[key]["neg"] : 0,
            }
            topics.push(obj);
          }
          dataSourceReport["topics"] = topics;


          let arrDomain = Array();
          for (var i = 0; i < newsDomain.length; i++) {
            let key = newsDomain[i]["key"];
            let count = newsDomain[i]["doc_count"];
            let obj = {
              domain: key,
              count: count,
              pos: 0,
              neu: 0,
              neg: 0
            };
            let sentiments = newsDomain[i].sentimentsCount.statistic.seg.buckets;
            for (var j = 0; j < sentiments.length; j++) {
              let segKey = sentiments[j]["key"];
              let segCount = sentiments[j]["doc_count"];
              obj[segKey] = segCount;
            }
            arrDomain.push(obj);
          }
          dataSourceReport["topNews"] = arrDomain;
          this.dataReport["data"] = dataSourceReport;
        } else {
          this.dataReport = {
            report_desc: "Báo cáo nguồn dữ liệu",
            report_type: type,
            report_name: "Báo cáo nguồn dữ liệu từ ngày " + this.daterangeFilter.start.format('DD/MM/YYYY') + " đến ngày " + this.daterangeFilter.end.format('DD/MM/YYYY'),
            report_project: this.projectSelectedFilter,
            report_brand: this.brandSelectedFilter,
            report_start_date: new Date(this.daterangeFilter.start.valueOf()),
            report_end_date: new Date(this.daterangeFilter.end.valueOf()),
            report_code: "BCNDL",
          };
          let aggs = data.aggregations;
          let news = aggs.news.domain.buckets;
          let pages = aggs.page.id.buckets;
          let arrNews = Array();
          let arrPage = Array();

          for (var i = 0; i < news.length; i++) {
            let obj = {
              name: news[i]["key"],
              total: news[i]["doc_count"]
            };
            arrNews.push(obj);
          }

          for (var i = 0; i < pages.length; i++) {
            let obj = {
              id: pages[i]["key"],
              name: pages[i]["name"].buckets[0]["key"],
              total: pages[i]["total_seeding"]["value"],
              likes: pages[i]["likeCount"]["value"],
              shares: pages[i]["shareCount"]["value"],
              comments: pages[i]["commentCount"]["value"]
            };
            arrPage.push(obj);
          }
          this.dataReport["data"] = { news: arrNews, pages: arrPage };
          console.log(this.dataReport);

        }
      }
    });
    // console.log(filter);
  }
  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }
      this.dataReport["report_title"] = this.reportName.trim();
      this.brandReportService.createReportManager(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }
  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }
  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef.hide();
    this.modalRef = this.modalService.show(modalRef);
  }

  deleteReport() {
    this.brandReportService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
  }

  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/brand-data-source/brand-data-source-reports.component.ts